import { ReactNode } from "react";
import {
  DataGridCell,
  getEntity,
} from "@components/common/data-grid/adm-data-grid-utils";
import { EntityCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { TestingImpersonationTableEntity } from "@pages/testing-impersonation/testing-impersonation-table-types";
import { CopyImpersonationButton } from "@components/impersonation/copy-impersonation-link";
import { Text, grey } from "@flat-ui";
import { Box } from "@mui-wrapper";

/** Return name and email cell in testing impersonation table */
export function TestingImpersonationNameAndEmailCell(
  params: EntityCellParams<TestingImpersonationTableEntity>
): ReactNode {
  const { name, email } = getEntity(params);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Text variant="bodyM">{name}</Text>
      <Text variant="bodyS" sx={{ color: grey[600] }}>
        {email}
      </Text>
    </Box>
  );
}

/** Return description cell in testing impersonation table */
export function TestingImpersonationDescriptionCell(
  params: EntityCellParams<TestingImpersonationTableEntity>
): ReactNode {
  return <DataGridCell content={getEntity(params).description} />;
}

/** Return login link cell in testing impersonation table */
export function TestingImpersonationLoginLinkCell(
  params: EntityCellParams<TestingImpersonationTableEntity>,
  numberedEnv: string
): ReactNode {
  return (
    <CopyImpersonationButton
      memberId={getEntity(params).memberId}
      numberedEnv={numberedEnv}
    />
  );
}
